import * as $ from 'jquery';

export class ScrollLock {
    static $html = $('html');
    static rule = 'lock-scroll';

    static lock(): void {
        $('body').attr('data-pos', $(window).scrollTop());
        this.$html.addClass(this.rule);
    }

    static unlock(): void {
        this.$html.removeClass(this.rule);
        $(window).scrollTop($('body').attr('data-pos') as any);
    }
}
